import React from "react";
import { useLocation, Navigate, Link } from "react-router-dom";
import useInstanceInfo from "../../hooks/useInstanceInfo";

const SignupConfirmation = () => {
  const location = useLocation();
  // Before the early return: hooks must run on every render. The marketing link is hidden until
  // the installation's settings load, and on customer-hosted installs.
  const { info: instanceInfo } = useInstanceInfo();

  if (!location.state?.signupSuccess) {
    return <Navigate to="/signup" replace />;
  }

  return (
    <div className="flex items-center justify-center h-screen bg-theme-primary">
      <div className="bg-theme-card-solid border border-border p-10 rounded-2xl shadow-xl w-96 text-center">
        <h1 className="text-3xl font-bold text-content-primary mb-6">Axaris AI</h1>

        <svg
          className="mx-auto mb-4 w-16 h-16 text-green-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <h2 className="text-xl font-semibold text-content-primary mb-4">
          Account Created Successfully
        </h2>

        <p className="text-content-secondary mb-2">
          A verification email has been sent to your email address.
        </p>
        <p className="text-content-tertiary text-sm mb-8">
          Please check your spam or junk folder if you don't see it in your inbox.
        </p>

        <Link
          to="/login"
          className="block w-full py-3 bg-gradient-primary hover:shadow-glow-cyan text-white rounded-xl font-medium transition text-center"
        >
          Go to Login
        </Link>

        {instanceInfo.showMarketingSiteLink && (
          <p className="mt-3 text-center">
            <a href="/landing.html" className="text-content-tertiary hover:text-content-secondary text-sm">
              &larr; Back to Home
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default SignupConfirmation;
